/**
 * SettingsTabs — shared tab bar across the Settings area (Settings · Team ·
 * Activity). Team and Activity used to be their own sidebar items; folding them
 * in here keeps the left nav short. Rendered at the top of /admin/settings,
 * /admin/team and /admin/audit.
 * @file src/web/features/admin/components/SettingsTabs.tsx
 *
 * Professional-only: Team + Activity are hidden for entity (client) logins, who only
 * get the Settings tab (their change-password lives there), so the bar collapses
 * to nothing for them.
 */

import { NavLink } from 'react-router-dom';
import { useAuth } from '../../auth/hooks';

export function SettingsTabs() {
  const { user } = useAuth();
  const roleLevel = `${user?.role}.${user?.level}`;
  const isEntity = roleLevel === 'moderator.approve' || roleLevel === 'moderator.review';

  const tabs = [{ label: 'Settings', href: '/admin/settings' }];
  if (!isEntity) tabs.push({ label: 'Team', href: '/admin/team' }, { label: 'Activity', href: '/admin/audit' });
  if (tabs.length === 1) return null;

  return (
    <div className="mb-6 inline-flex rounded-xl border border-ink-200 bg-paper p-1">
      {tabs.map((t) => (
        <NavLink
          key={t.href}
          to={t.href}
          end
          className={({ isActive }) =>
            `rounded-lg px-4 py-2 text-sm font-medium no-underline transition ${isActive ? 'bg-inkblack text-white' : 'text-ink-600 hover:bg-ink-50'}`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
